import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const EMPTY_PROFILE = { first_name: "", last_name: "", phone: "", email: "", dob: "", license_number: "", license_state: "", license_class: "", license_expiry: "" };
export const PROFILE_KEYS = Object.keys(EMPTY_PROFILE);
export const profileValid = (f) => f.first_name.trim() && f.last_name.trim() && f.phone.replace(/\D/g, "").length >= 7 && (!f.email.trim() || /^\S+@\S+\.\S+$/.test(f.email.trim()));
// Blank dates go to the API as null.
export const profileBody = (f) => ({ ...Object.fromEntries(PROFILE_KEYS.map((k) => [k, (f[k] || "").trim()])), dob: f.dob || null, license_expiry: f.license_expiry || null });

const F = ({ k, label, f, set, ...p }) => (
  <div>
    <Label htmlFor={`drv-${k}`}>{label}</Label>
    <Input id={`drv-${k}`} className="mt-1.5 h-11" value={f[k] || ""} onChange={(e) => set(k, e.target.value)} data-testid={`driver-${k}-input`} {...p} />
  </div>
);

const Group = ({ title, children }) => (
  <fieldset className="space-y-3">
    <legend className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">{title}</legend>
    <div className="grid sm:grid-cols-2 gap-4">{children}</div>
  </fieldset>
);

export const ProfileFields = ({ f, set }) => (
  <div className="space-y-6">
    <Group title="Name & contact">
      <F k="first_name" label="First name *" f={f} set={set} autoComplete="off" />
      <F k="last_name" label="Last name *" f={f} set={set} autoComplete="off" />
      <F k="phone" label="Phone *" f={f} set={set} type="tel" placeholder="(555) 123-4567" />
      <F k="email" label="Email (optional)" f={f} set={set} type="email" placeholder="driver@example.com" />
      <F k="dob" label="Date of birth (optional)" f={f} set={set} type="date" />
    </Group>
    <Group title="Driver's license (optional)">
      <F k="license_number" label="License number" f={f} set={set} maxLength={40} />
      <F k="license_state" label="State of issue" f={f} set={set} maxLength={2} placeholder="e.g. TX" className="mt-1.5 h-11 uppercase" />
      <F k="license_class" label="Class" f={f} set={set} maxLength={10} placeholder="e.g. A" />
      <F k="license_expiry" label="Expiration date" f={f} set={set} type="date" />
    </Group>
  </div>
);
